import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { z } from "zod";

export const filterA7OPCVMUnderlyingsSchema = z.object({
  type_instrument_du_sous_jacent_contains: z.string().optional(),
  devise_du_sous_jacent_contains: z.string().optional(),
  code_isin_du_sous_jacent_contains: z.string().optional(),
  denomination_du_sous_jacent_contains: z.string().optional(),
});

const fields: Field[] = [
  {
    name: "type_instrument_du_sous_jacent_contains",
    label: `Type d'instrument`,
    type: "input",
  },
  {
    name: "devise_du_sous_jacent_contains",
    label: "Devise",
    type: "input",
  },
  {
    name: "code_isin_du_sous_jacent_contains",
    label: "ISIN",
    type: "input",
  },
  {
    name: "denomination_du_sous_jacent_contains",
    label: "Émetteur",
    type: "input",
  },
];

export function FilterA7OPCVMUnderlyings() {
  return (
    <FilterTable
      schema={filterA7OPCVMUnderlyingsSchema}
      tableName="a7_opcvm_underlyings"
      fields={fields}
      client="a7"
      customBuildPath={() => `a7-opcvm/a7_opcvm_underlyings`}
    />
  );
}
